// extracted by mini-css-extract-plugin
export default {"logo":"trust-arc-logo-module__logo","wrapper":"trust-arc-logo-module__wrapper","support":"trust-arc-logo-module__support","clock-icon":"trust-arc-logo-module__clock-icon"};